import { WorkOrderState } from '../../interfaces'
import {
  GET_WORKORDERSTATE_EXITO,
  GET_WORKORDERSTATE
} from '../types/workOrderStateActionsTypes'

export type WorkOrderStateAction =
  | WorkOrderStatesAction
  | WorkOrderStateActionAsync

// Esto va a REDUX
export interface WorkOrderStatesAction {
  type: typeof GET_WORKORDERSTATE_EXITO
  workOrderStates: WorkOrderState[] | undefined
  error: string | undefined
}

export const getWorkOrderStatesAction = (
  workOrderStates?: WorkOrderState[],
  error?: string
): WorkOrderStatesAction => {
  return {
    type: GET_WORKORDERSTATE_EXITO,
    workOrderStates: workOrderStates,
    error
  }
}

// Esto va a SAGA
export interface WorkOrderStateActionAsync {
  type: typeof GET_WORKORDERSTATE
}

export const getWorkOrderStatesActionAsync = (): WorkOrderStateActionAsync => {
  return {
    type: GET_WORKORDERSTATE
  }
}
